<template>
  <div class="sort-list">
    <p>排序设置</p>
    <div class="button">
      <span :class="{'active': sortType === 'created'}" @click="selectSort('created')">最新发布</span>
      <span :class="{'active': sortType === 'readNum'}" @click="selectSort('readNum')">最多阅读</span>
      <span :class="{'active': sortType === 'name_sort'}" @click="selectSort('name_sort')">名称从A到Z</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SortList',
  props: {

  },
  components: {

  },
  data () {
    return {
      sortType: 'created'
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    selectSort (type) {
      this.sortType = type
      this.$emit('select-sort', type)
    }
  }
}
</script>
<style lang="postcss" scoped>
.sort-list {
  & > p {
    color: #1B2532;
    font-family: "PingFang SC";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }

  & .button {
    display: flex;
    flex-wrap: wrap;
    margin-top: 12px;
    width: 100%;

    & span {
      width: calc((100% - 16px) / 2);
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      border: 1px solid #D8E0E8;
      background: #fff;
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      margin-top: 16px;
      margin-right: 16px;
      box-sizing: border-box;

      &.active {
        background: #006BFF;
        border: 1px solid #006BFF;
        color: #fff;
      }

      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
</style>
